import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "NavigationOverview",
    component: () =>
        __SERVER__ ? require("./navigation-overview-view") : import("./navigation-overview-view")
});

export default definition;
